// SEO-facing topic descriptions — used by TopicPage.jsx, LandingPage.jsx and
// vite.config.js's prerender step. Keep in sync with the 10 topic rows in the DB.
export const TOPIC_DESCRIPTIONS = {
  finance: "Questions about investing, budgeting, crypto, banking, taxes and personal finance",
  technology: "Questions about computers, phones, software, internet, coding and tech support",
  health: "Questions about fitness, nutrition, mental health, medical symptoms and wellness",
  science: "Questions about physics, chemistry, biology, astronomy and earth science",
  business: "Questions about startups, marketing, sales, entrepreneurship and freelancing",
  culture: "Questions about traditions, identity, African culture, British and American customs",
  ai: "Questions about artificial intelligence, machine learning, ChatGPT and AI tools",
  travel: "Questions about destinations, flights, hotels, visas and budget travel tips",
  politics: "Questions about government, elections, political systems and current affairs",
  sports: "Questions about football, basketball, cricket, tennis, golf and combat sports",
};

export const TOPIC_SLUGS = Object.keys(TOPIC_DESCRIPTIONS);

// Display names matching the `topics` DB table — used as a fallback when the
// topics API is unreachable so a known-valid topic slug still renders real
// content (and stays indexable) instead of a false 404.
export const TOPIC_NAMES = {
  finance: "Finance",
  technology: "Technology",
  health: "Health",
  science: "Science",
  business: "Business",
  culture: "Culture",
  ai: "AI",
  travel: "Travel",
  politics: "Politics",
  sports: "Sports",
};
